// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"40378f05","977":"3bd1f95c"}[chunkId] + ".chunk.js";
};